import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import { FormikEntityActionConfigFields, FormikField } from '../../../Formik'
import { InputField } from '../../../Input'
import { DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH } from '../../Document.constants'
import { DOCUMENT_EDIT_ACTION_TITLE_FIELD_NAME } from '../DocumentEditActionModal.constants'

function DocumentEditActionModalFields({ typeSelectProps }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields typeSelectProps={typeSelectProps} />
      <FormikField
        autoFocus
        clearable
        hasCounter
        required
        Component={InputField}
        Field={FieldStackedLabel}
        label={t('Modal.DocumentEditActionModalNameFieldLabelKey')}
        maxLength={DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH}
        name={DOCUMENT_EDIT_ACTION_TITLE_FIELD_NAME}
        placeholder={t('Modal.DocumentEditActionModalNamePlaceholderKey')}
      />
    </FormFieldsContainer>
  )
}

export default DocumentEditActionModalFields
